export const PaymentHistory = '/PaymentHistory'